// extracted by mini-css-extract-plugin
module.exports = {"event-layout":"_3upqZ","desk-event-layout":"_3jceB","wrapper":"GB9To","shake":"_2OFHA"};